import { registerSW } from 'virtual:pwa-register'

export const serviceWorkerHelper = {
  install: () => {
    registerSW()
  },
}
